import React from 'react'
import { iconMap } from '../../assets/images/clinics/iconMap'
import useIsMobile from '../../hooks/useIsMobile'
import {
  BackTitle,
  Bold,
  Card,
  CardLabel,
  Container,
  Grid,
  Subtitle,
  Title,
  WaitLabel
} from './styled'
import theme from '../../styles/theme'
import styled from 'styled-components'
import { isCurrentTimeInRange } from '../../utils/isCurrentTimeInRange'

const GUARDIA_SPECIALITY_ID_GINE = 5
const GUARDIA_SPECIALITY_ID_OBSTETRICA = 2

const CLINICA_SANTA_ISABEL_ID = 387124
const CLINICA_BAZTERRICA_ID = 387122

const Clinic = ({ clinics, saveClinic, clear, speciality }) => {
  const isMobile = useIsMobile()

  const filteredClinics = clinics.filter(({ clinica }) => {
    if (speciality && speciality.idEspecialidad === GUARDIA_SPECIALITY_ID_GINE)
      return clinica.codigoEmpresa === CLINICA_SANTA_ISABEL_ID

    if (speciality && speciality.idEspecialidad === GUARDIA_SPECIALITY_ID_OBSTETRICA)
      return clinica.codigoEmpresa === CLINICA_BAZTERRICA_ID
    return true
  })

  return (
    <Container>
      {!isMobile && (
        <BackTitle onClick={() => clear()}>
          <span>‹</span> Volver
        </BackTitle>
      )}
      <Title>Ingresá a la fila de la guardia</Title>
      <Subtitle>¿En qué clínica querés atenderte?</Subtitle>
      <Grid>
        {filteredClinics.map(({ clinica, espera, horaFin, horaInicio }) => {
          const clinicStartTime = horaInicio || clinica.horaInicio
          const clinicEndTime = horaFin || clinica.horaFin
          const IconComponent = iconMap[clinica.codigoEmpresa] || iconMap['default']
          const hasTimeRange = Boolean(clinicStartTime && clinicEndTime)
          const isDisabled = hasTimeRange
            ? !isCurrentTimeInRange(clinicStartTime, clinicEndTime)
            : false
          const handleCardClick = () => {
            if (isDisabled) return

            saveClinic({
              id: clinica.id,
              name: clinica.nombre,
              waitTime: espera,
              horaInicio: clinicStartTime,
              horaFin: clinicEndTime
            })
          }
          return (
            <Card
              key={clinica.id}
              onClick={handleCardClick}
              disabled={isDisabled}
            >
              <IconWrapper disabled={isDisabled}>
                {IconComponent && (
                  <IconComponent
                    primaryColor={
                      isDisabled ? theme.colors.greys.disabled : theme.colors.brand.blueOmint
                    }
                    aria-label={clinica.nombre}
                  />
                )}
              </IconWrapper>
              <div style={{ textAlign: isMobile ? 'left' : 'center' }}>
                <CardLabel>{clinica.nombre}</CardLabel>
                <WaitLabel>
                  Tiempo de espera aprox:
                  <Bold>{` ${espera} min`}</Bold>
                </WaitLabel>
              </div>
            </Card>
          )
        })}
      </Grid>
    </Container>
  )
}


const IconWrapper = styled.div`
  cursor: ${props => (props.disabled ? 'not-allowed' : 'inherit')};
`

export default Clinic
